import React from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    useLocation
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Dashboard from './pages/dashboard/Dashboard';
import PrivateRoute from './components/common/PrivateRoute';
import PublicBlogPortal from './pages/public/PublicBlogPortal';


/* =========================
   🔍 Advanced Device Detection
   ========================= */
//const isMobileDevice = () => {
//    const ua = navigator.userAgent || navigator.vendor || window.opera;

//    // Basic mobile detection
//    const mobileRegex = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;

//    // Touch capability (most mobiles)
//    const hasTouch =
//        'ontouchstart' in window ||
//        navigator.maxTouchPoints > 0 ||
//        navigator.msMaxTouchPoints > 0;

//    // Screen size check
//    const smallScreen = window.innerWidth <= 1024;

//    // Low device memory (mobile indicator)
//    const lowMemory = navigator.deviceMemory && navigator.deviceMemory <= 4;

//    // Platform hint
//    const isMobilePlatform = /android|iphone|ipad/i.test(ua);

//    return (
//        mobileRegex.test(ua) ||
//        (hasTouch && smallScreen) ||
//        (isMobilePlatform && hasTouch) ||
//        lowMemory
//    );
//};

const isMobileDevice = () => {
    // Detect coarse pointer (finger) vs fine (mouse/trackpad)
    const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;

    // Detect no hover capability (typical mobile)
    const noHover = window.matchMedia('(hover: none)').matches;

    // Small viewport (real mobile)
    const smallScreen = window.innerWidth <= 768;

    return isCoarsePointer && noHover && smallScreen;
};


/* =========================
   🚫 Block Screen UI
   ========================= */
const MobileBlock = () => {
    return (
        <div
            style={{
                height: '100vh',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                background: 'radial-gradient(circle at top, #020617, #000)',
                color: '#fff',
                textAlign: 'center',
                padding: '20px'
            }}
        >
            <h1 style={{ fontSize: '2.8rem', marginBottom: '10px' }}>
                🚫 Desktop Only
            </h1>

            <p style={{ opacity: 0.85 }}>
                This platform is restricted to desktop/laptop devices.
            </p>

            <p style={{ opacity: 0.6, marginTop: '8px' }}>
                Mobile devices (even in desktop mode) are not supported.
            </p>
        </div>
    );
};


/* =========================
   🌐 Routes Wrapper
   ========================= */
const AppRoutes = () => {
    const location = useLocation();

    const isMobile = isMobileDevice();

    // ✅ Allow blogs on mobile
    if (isMobile && !location.pathname.startsWith('/blogs')) {
        return <MobileBlock />;
    }

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />

                {/* ✅ Public blogs (allowed on mobile) */}
                <Route path="/blogs" element={<PublicBlogPortal />} />

                {/* ❌ Protected desktop-only */}
                <Route
                    path="/dashboard/*"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                />

                <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </>
    );
};


/* =========================
   🚀 Main App
   ========================= */
function App() {
    return (
        <Router>
            <div className="App">
                <AppRoutes />
            </div>
        </Router>
    );
}

export default App;